import cn from 'bem-cn';

import { Icon, Skeleton, Stack } from '../../UI';
import { PHANTOMAS_ACHIEVEMENT_IMAGE } from '../../../constants';

import { AchievementModalProps } from './AchievementModal.types';
import './AchievementModal.scss';

const b = cn('achievement-modal');

export const AchievementModalSkeleton = (props: Partial<AchievementModalProps>) => {
    const { onClose } = props;

    return (
        <Stack className={b()}>
            <div className={b('header')}>
                <Stack className={b('header-button')}>
                    <Icon name="share" size={48} aria-label="Поделиться" disabled />
                </Stack>
                <Stack className={b('header-button')}>
                    <Icon name="close" size={48} aria-label="Закрыть" onClick={onClose} />
                </Stack>
            </div>
            <Stack spacing={8} className={b('content', { skeleton: true })}>
                <img className={b('image')} src={PHANTOMAS_ACHIEVEMENT_IMAGE} alt="" />
                <h2>
                    <Skeleton width="100%" />
                </h2>
                <p className={b('season')}>
                    <Skeleton width="20%" />
                </p>
                <Stack as="p" spacing={4}>
                    <Skeleton width="90%" />
                    <Skeleton width="100%" />
                    <Skeleton width="70%" />
                    <Skeleton width="100%" />
                </Stack>
            </Stack>
            <div className={b('separator')} />
            <Stack spacing={8} className={b('footer', { skeleton: true })}>
                <Skeleton width="60%" style={{ margin: '0 auto' }} />
                <h3>
                    <Skeleton width="100%" />
                </h3>
            </Stack>
        </Stack>
    );
};
